
export const getScoreText = (score: number) => {
  if (score >= 80) return '¡Excelente!';
  if (score >= 60) return '¡Buen trabajo!';
  if (score >= 40) return 'Puede mejorar';
  return 'Necesita atención';
};

export const getScoreColor = (score: number) => {
  if (score >= 80) return 'from-green-400 to-green-600';
  if (score >= 60) return 'from-blue-400 to-blue-600';
  if (score >= 40) return 'from-yellow-400 to-yellow-600';
  return 'from-red-400 to-red-600';
};

export const getBmiStatusText = (bmi: number) => {
  if (bmi < 16) return 'Bajo peso severo';
  if (bmi < 18.5) return 'Bajo peso';
  if (bmi <= 24.9) return 'Peso normal';
  if (bmi <= 29.9) return 'Sobrepeso';
  if (bmi <= 34.9) return 'Obesidad grado I';
  if (bmi <= 39.9) return 'Obesidad grado II';
  return 'Obesidad grado III';
};

export const getBmiHealthStatus = (bmi: number) => {
  if (bmi >= 18.5 && bmi <= 24.9) return 'IMC Saludable';
  return 'IMC No Saludable';
};
